import { render, staticRenderFns } from "./ECommerceFansLayout.vue?vue&type=template&id=40ac1f2a&scoped=true&"
import script from "./ECommerceFansLayout.vue?vue&type=script&lang=js&"
export * from "./ECommerceFansLayout.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceFansLayout.vue?vue&type=style&index=0&id=40ac1f2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac1f2a",
  null
  
)

export default component.exports